/**
 * @module $Name$
 */
import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import '@babel/polyfill';
import Routes from './components/Routes';
import configureStore from './store/configurestore';
import config from './auth/config';
/* this below import of svg appears unused, but it's required so
 * that Webpack will include it in the main package, enabling
 * SVG support in the UI. */
import './util/svg';
import env from './util/env';
import initialState from './reducers/initialstate';
import {getAppInsights} from './components/Common/AppInsight/TelemetryService';
import TelemetryProvider from './components/Common/AppInsight/TelemetryProvider';
import initDocHelper from './components/Common/DocumentHub/DocumentHub';
import {setLanguage} from './util/utils';
import {getUserPreferences, updateIsPreferencesLoaded} from './actions/userpreferences/userpreferencesaction';
import {getEngagementRoles} from './actions/MasterData/getRolesAction';
import {serviceURL, attributeListSkipTaskOpen} from './util/uiconstants';
import utility from './util/utilityfunctions';
import {Providers, ProviderState, Graph} from '@microsoft/mgt';
import {checkUserAcceptedPaansPolicy} from './actions/Paans/paansaction';
import queryString from 'query-string';
import {MsalService} from '@ey/voltron-core';
import {Client} from '@microsoft/microsoft-graph-client';
//import {receiveLiveUpdate} from './actions/LiveUpdates/liveUpdatesActions';
import {initTeamsProvider} from '@ey/canvascoreservices-teams';
import {setIsCurrentResourceAvailable} from './actions/currentresouceactions';
import {LicenseManager} from 'ag-grid-enterprise';
import {licenseSetter} from '@ey/canvascoreservices/AGGridEnterprise';
import ReactDOM from 'react-dom';

LicenseManager.setLicenseKey(
	// eslint-disable-next-line max-len
	'Using_this_{AG_Grid}_Enterprise_key_{AG-059616}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Ernst_&_Young_U.S._LLP}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{EY_Canvas}_only_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{EY_Canvas}_need_to_be_licensed___{EY_Canvas}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{28_July_2025}____[v3]_[01]_MTc1MzY1NzIwMDAwMA==4f80980272aef5f53d439b27c9ceb64c'
);

licenseSetter(
	'Using_this_{AG_Grid}_Enterprise_key_{AG-059616}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Ernst_&_Young_U.S._LLP}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{EY_Canvas}_only_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{EY_Canvas}_need_to_be_licensed___{EY_Canvas}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{28_July_2025}____[v3]_[01]_MTc1MzY1NzIwMDAwMA==4f80980272aef5f53d439b27c9ceb64c'
);

let engWeb = env.getURL('eng_web');
let paths = location.pathname.split('/');
if (paths[1].toLowerCase() === 'v1redirect') {
	let queryStringParams = queryString.parse(location.search.toLowerCase());
	var redirectedBy = '&rdFrom=clt';
	if (paths[2]?.toLowerCase() === 'engagementprofile') {
		engWeb = env.getURL('kronos_web') + '/initprofile?engagementid=' + queryStringParams.engagementid;
		engWeb = engWeb + '&referrer=' + env.getURL('Zeus_web') + redirectedBy;
	} else if (queryStringParams.showindependence && queryStringParams.showindependence == 'true') {
		engWeb = env.getURL('kronos_web') + '/independence?engagementid=' + queryStringParams.engagementid;
		engWeb = engWeb + '&referrer=' + env.getURL('Zeus_web') + redirectedBy;
	} else if (queryStringParams.grantarchiveaccess && queryStringParams.grantarchiveaccess == 'true') {
		// Navigate to manage team for archived engagement
		engWeb = location.origin + '/manageteam?engagementid=' + queryStringParams.engagementid;
	} else if (queryStringParams.viewinstruction || queryStringParams.updatedinstructions) {
		// Navigate to receive instructions page
		const isNew = !!queryStringParams.viewinstruction;
		engWeb =
			location.origin +
			'/receiveinstructions?engagementid=' +
			queryStringParams.engagementid +
			'&componentguid=' +
			queryStringParams.gacomponentguid +
			'&isnew=' +
			isNew;
	} else {
		engWeb = engWeb + '/pages/index/index.html' + location.search + redirectedBy;
	}
	location.href = engWeb;
}

// Redirect to the new documents URL.
if (paths[1].toLowerCase() === 'documents') {
	const herculesWeb = env.getURL('hercules_web');
	if (location.search.includes('category=documents')) {
		location.href = herculesWeb + '/dashboard/' + location.search + location.hash;
	} else {
		const path = location.search.substring(1);
		location.href = herculesWeb + '/dashboard/?category=documents&' + path + location.hash;
	}
}

// below listener is added to fix the issue with deep routing for PAAS environments
// TODO: Remove after all features with #routes in v1 are migrated to hercules
var v1redirection = (event) => {
	if (event.ctrlKey || event.shiftKey) {
		return;
	}

	const a = event.target.closest('a');
	if (a && a.attributes['href']) {
		var urlVal = _.trimStart(a.attributes['href'].value, '/');
		console.log('🐱‍👤', urlVal);
		let engWeb = env.getURL('eng_web');
		if (urlVal.split(engWeb).length > 1) {
			const svg = event.target.closest('svg');
			if (svg && svg.classList && svg.classList.length > 0 && attributeListSkipTaskOpen.includes(svg.classList[0])) {
				// Return if click on tagIcon in TaskList item
				return;
			}
			if (event.target && event.target.id && attributeListSkipTaskOpen.includes(event.target.id)) {
				// Return if click on tag count in TaskList item
				return;
			}

			if (event.target.closest('.tooltip-Menu-TasklistItem')) {
				// when user click on tooltip menu for tag and service request icon
				return;
			}

			event.preventDefault();
			var hash = new URL(urlVal).hash;
			let urlWithoutHash = urlVal.split('#')[0];
			let isTaskRoute = hash.includes('#task/');
			const openInNewTab = a.dataset.opennewtab;
			if (hash) {
				urlWithoutHash = _.trimEnd(urlWithoutHash, '&') + hash;
			}

			if (isTaskRoute || openInNewTab) {
				window.open(urlWithoutHash, '_blank');
			} else {
				window.location.href = urlWithoutHash;
			}
		}
	}
};
window.removeEventListener('click', v1redirection, true);
window.addEventListener('click', v1redirection, true);

document.addEventListener('DOMContentLoaded', () => {
	const store = configureStore(initialState);

	/*
	document.addEventListener('keydown',(e)=>{
		if(e.ctrlKey && e.key ==='/'){
			console.log('🎲🎲🎲🎲');
			let c = {
				"Sender": "dca40214-b4e9-e811-9f2a-0003ff433e22",
				"EventType": "ey.at.hercules.annotation.created",
				"Subject": "hercules/us/annontaion",
				"Payload": "{\"id\":8666,\"text\":\"Review note 1\",\"parentAnnotation\":null,\"statusId\":1,\"editable\":false,\"createDate\":\"2021-07-30T20:41:51.8081847Z\",\"referenceNumber\":69,\"priorityTypeId\":null,\"dueDate\":null,\"assignedToUserName\":null,\"createUserName\":\"Karthic RamiyaKrishnamoorthy\",\"assignedToUserId\":null,\"createUserId\":\"dca40214-b4e9-e811-9f2a-0003ff433e22\",\"statusChangeUserName\":null,\"statusChangeDate\":null,\"statusChangeUserID\":null,\"replyCount\":0,\"entityID\":0,\"entityUID\":null,\"engagementId\":1576574,\"documentEngagementID\":0,\"documentConfidentialityTypeID\":0,\"engagementDescription\":null,\"categoryDisplayName\":null,\"taskPrefix\":null,\"taskSufix\":null,\"docExtension\":null,\"isConflicted\":false,\"isCommented\":false,\"isHighlighted\":false,\"hasTrackChanges\":false,\"hasHiddenSheets\":false,\"taskTypeId\":0,\"isEPTask\":false,\"isEQRTask\":false,\"taskVersion\":null,\"modifiedDate\":\"0001-01-01T00:00:00\",\"annotationTypeId\":0,\"documentTypeId\":0,\"documentChangeTypeId\":null,\"replies\":null,\"responses\":null}"
			};
			store.dispatch(receiveLiveUpdate(c));
		}

		if(e.ctrlKey && e.key ===';'){
			console.log('🎲🎲🎲🎲');
			let c = {
				"Sender": "dca40214-b4e9-e811-9f2a-0003ff433e22",
				"EventType": "ey.at.hercules.annotation.replied",
				"Subject": "hercules/us/annontaion",
				"Payload": "{\"id\":8666,\"text\":\"Review note 1\",\"parentAnnotation\":null,\"statusId\":1,\"editable\":false,\"createDate\":\"2021-07-30T20:41:51.8081847Z\",\"referenceNumber\":69,\"priorityTypeId\":null,\"dueDate\":null,\"assignedToUserName\":null,\"createUserName\":\"Karthic RamiyaKrishnamoorthy\",\"assignedToUserId\":null,\"createUserId\":\"dca40214-b4e9-e811-9f2a-0003ff433e22\",\"statusChangeUserName\":null,\"statusChangeDate\":null,\"statusChangeUserID\":null,\"replyCount\":0,\"entityID\":0,\"entityUID\":null,\"engagementId\":1576574,\"documentEngagementID\":0,\"documentConfidentialityTypeID\":0,\"engagementDescription\":null,\"categoryDisplayName\":null,\"taskPrefix\":null,\"taskSufix\":null,\"docExtension\":null,\"isConflicted\":false,\"isCommented\":false,\"isHighlighted\":false,\"hasTrackChanges\":false,\"hasHiddenSheets\":false,\"taskTypeId\":0,\"isEPTask\":false,\"isEQRTask\":false,\"taskVersion\":null,\"modifiedDate\":\"0001-01-01T00:00:00\",\"annotationTypeId\":0,\"documentTypeId\":0,\"documentChangeTypeId\":null,\"replies\":null,\"responses\":null}"
			};
			store.dispatch(receiveLiveUpdate(c));
		}
	})
	*/

	console.log('🌵 <<< DOM loaded >>> 🌵');

	store.dispatch({type: 'HOME_LOGIN'}).then(async () => {
		$('<iframe />')
			.attr({
				id: 'communicationchannel',
				src: `${env.getURL('Zeus_web')}/pages/communicationChannel/communicationchannel.html`
			})
			.hide()
			.appendTo('body');

		const authService = new MsalService(config);
		const account = await authService.getActiveAccountAsync();

		if (account) {
			initTeamsProvider(config)
				.then((provider) => {
					const options = {
						authProvider: provider,
						fetchOptions: {headers: {'X-PeopleQuery-QuerySources': 'Mailbox,Directory'}}
					};
					const client = Client.initWithMiddleware(options);
					provider.graph = new Graph(client);
					Providers.globalProvider = provider;
					Providers.globalProvider.setState(ProviderState.SignedIn);
				})
				.catch((error) => {
					console.log('error', error);
				});
		}
		let engagementId = utility.getEngagementIdFromUrl(window);
		let requestURL = env.getBaseURL(serviceURL, engagementId) + 'Users/Me';

		console.log('Before getUserPreferences()');
		const isLocalLandingPage = window.location.pathname.toLowerCase().includes('/locallandingpage');
		const tempResponse = !isLocalLandingPage ? store.dispatch(getUserPreferences(requestURL)) : Promise.resolve();
		tempResponse
			.then((response) => {
				console.log('After getUserPreferences()');
				let intervalFunc;
				const delayFunc = () => {
					const storeState = store.getState();
					if (!storeState.userPreferences.displayLanguage) {
						return;
					}
					clearInterval(intervalFunc);
					setLanguage(storeState.userPreferences.displayLanguage);
					store.dispatch(setIsCurrentResourceAvailable(true));

					let rolesUrl = env.getBaseURL(serviceURL) + 'Roles';
					store.dispatch(getEngagementRoles(rolesUrl));
					/**
					 * sending UPN using logged in account so that docHelper can be initialitzed based on UPN route
					 * DocHelper init is chained to userpreference call so that any error on DocHelper can be displayed in preferred Language
					 */
					let _upn = account ? account.username : storeState.userPreferences.emailAddress;
					env.setDocHelperConfig(_upn).then(() => {
						initDocHelper(store)
							.then(() => {
								console.log('📃 ###Init Dochelper ###');
								if (storeState.apponlinestate) {
									console.log('STARTING SYNC IN main.js after HOME_LOGIN');
									store.dispatch({
										type: 'START_OFFLINE_SYNC',
										docHelperConfig: env.getDocHelperConfig()
									});
								}
							})
							.catch((e) => {
								console.log('Error in docHelperInit: ', e);
							});
					});
				};

				intervalFunc = setInterval(delayFunc, 100);
			})
			.catch((e) => {
				console.log('Error in getUserPreferences call: ', e);
				let rolesUrl = env.getBaseURL(serviceURL) + 'Roles';
				store.dispatch(getEngagementRoles(rolesUrl));
			})
			.finally(() => {
				if (isLocalLandingPage) {
					store.dispatch(updateIsPreferencesLoaded(true));
				}
				//  get PAANS User information
				let paansUrl = env.getBaseURL(serviceURL) + 'Paans';
				console.log('Before checkUserAcceptedPaansPolicy()');
				store
					.dispatch(checkUserAcceptedPaansPolicy(paansUrl))
					.then(() => {
						console.log('After checkUserAcceptedPaansPolicy()');
						let userHasAcceptedPolicy = store.getState().paansuserdata;
						let hasaccepted = userHasAcceptedPolicy.hasAccepted;
						let redirectUrl = userHasAcceptedPolicy.redirectUrl;
						if (hasaccepted !== undefined && redirectUrl !== undefined) {
							if (hasaccepted === false) {
								window.location.href = redirectUrl;
							}
						}
					})
					.catch((paansError) => {
						let errorMessage = utility.getErrorMessageFromResponse(utility.getErrorMessage(paansError));
						console.log('Error in PAANS: ', errorMessage);
					});
			});

		const root = ReactDOM.createRoot(document.getElementById('mount'));

		let appInsights;
		let instrumentation_Key = env.getInstrumentationKey();

		root.render(
			/*Provider component attaches the store to React components*/
			<Provider store={store}>
				<BrowserRouter>
					{store.getState().apponlinestate && env.isProd() ? (
						<TelemetryProvider
							instrumentationKey={instrumentation_Key}
							after={() => {
								appInsights = getAppInsights();
							}}
						>
							<Routes />
						</TelemetryProvider>
					) : (
						<Routes />
					)}
				</BrowserRouter>
			</Provider>
		);
	});
});
